
          import "SelectSearchInput_i2teht.linaria.css";
          import React, { forwardRef, useContext } from "react";
import { styled } from "@linaria/react";
import { focusStyle } from "@carvana/showroom-css-theme";
import BaseButton from "../../Button/Base";
import SearchIcon from "../../icons/search-16px.svg";
import CloseIcon from "../../icons/close-16px.svg";
import { SelectContext } from "../state";
const SearchInputWrapper = /*#__PURE__*/styled("div")({
  name: "SearchInputWrapper",
  class: "sen3z43"
});
const SearchInput = /*#__PURE__*/styled("input")({
  name: "SearchInput",
  class: "sjoptv2"
});
const ClearButton = /*#__PURE__*/styled(BaseButton)({
  name: "ClearButton",
  class: "c11xws5v"
});

const defaultOnChangeCallback = (searchValue, options) => {
  return options.filter(option => searchValue ? option.includes(searchValue) : true);
};

const SelectSearchInput = ({
  callback,
  innerRef
}) => {
  const {
    options,
    setFilteredOptions
  } = useContext(SelectContext);
  const {
    current
  } = options;

  const onChange = event => {
    const {
      value
    } = event.target;
    const cb = callback || defaultOnChangeCallback;
    const result = cb(value, current?.options ?? []);
    const filteredOptions = Array.isArray(result) ? result : [result];
    setFilteredOptions(filteredOptions);
  };

  const clearSearch = () => {
    setFilteredOptions(current?.options ?? []);

    if (innerRef.current) {
      innerRef.current.value = "";
    }
  };

  return /* @__PURE__ */React.createElement(SearchInputWrapper, null, /* @__PURE__ */React.createElement(SearchInput, {
    type: "text",
    placeholder: "Search",
    onChange,
    ref: innerRef
  }), /* @__PURE__ */React.createElement(SearchIcon, {
    className: "search__magnifyIcon"
  }), /* @__PURE__ */React.createElement(ClearButton, {
    "aria-label": "Clear Search",
    onClick: clearSearch
  }, /* @__PURE__ */React.createElement(CloseIcon, null)));
};

export default forwardRef((props, ref) => /* @__PURE__ */React.createElement(SelectSearchInput, { ...props,
  innerRef: ref
}));
          